import React from "react";
import PropTypes from "prop-types";

import Text from "components/common/Text";
import Select from "components/common/Select";

import "./CarryForwardRules.scss";

const expiryUnitOptions = [
  { value: "day(s)", label: "day(s)" },
  { value: "month(s)", label: "month(s)" },
  { value: "year(s)", label: "year(s)" },
];

function CarryForwardRules({ field, value: valueFromProps, name, setFormValues, isDisabled = false }) {
  const { labels } = field;
  const {
    limit: limitLabel = "Maximum carry forward limit",
    expiry: expiryLabel = "Carry forward leaves expire after",
  } = labels || {};

  const limit = valueFromProps?.limit || "";
  const expiry = valueFromProps?.expiry || "0";
  const expiryUnit = valueFromProps?.expiryUnit || "year(s)";
  const maxLimitUnit = valueFromProps?.maxLimitUnit || "days(s)";

  const handleLimitChange = (e) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: {
        ...valueFromProps,
        limit: e.target.value,
      },
    }));
  };

  const handleExpiryChange = (e) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: {
        ...valueFromProps,
        expiry: e.target.value,
      },
    }));
  };

  const handleExpiryUnitChange = (newValue) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: {
        ...valueFromProps,
        expiryUnit: newValue,
      },
    }));
  };

  const handleMaxLimitUnitChange = (newValue) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: {
        ...valueFromProps,
        maxLimitUnit: newValue,
      },
    }));
  };

  return (
    <div className="carry-forward-rules-field">
      <div className="carry-forward-inputs">
        <div className="limit-input-container">
          <span className="para-body-m-medium text-headings-secondary">{limitLabel}</span>
          <div className="limit-input-inner-container">
            <div className="limit-input-textfield">
              <Text
                name="carryForwardLimit"
                type="text"
                value={limit}
                onChange={handleLimitChange}
                variant="outlined"
                size="small"
                label=""
                hideHelperText
                disabled={isDisabled}
              />
            </div>

            <Select
              name="maxLimitUnit"
              className="limit-input-select"
              value={maxLimitUnit}
              onChange={handleMaxLimitUnitChange}
              options={expiryUnitOptions}
              variant="outlined"
              size="small"
              label=""
              disabled={isDisabled}
            />
          </div>
        </div>

        <div className="expiry-main-container">
          <span className="para-body-m-medium text-headings-secondary">{expiryLabel}</span>
          <div className="expiry-container">
            <div className="expiry-input mr-1">
              <Text
                name="carryForwardExpiry"
                type="text"
                value={expiry}
                onChange={handleExpiryChange}
                variant="outlined"
                size="small"
                label=""
                hideHelperText
                disabled={isDisabled}
              />
            </div>

            <Select
              name="expiryUnit"
              className="expiry-unit-select"
              value={expiryUnit}
              onChange={handleExpiryUnitChange}
              options={expiryUnitOptions}
              variant="outlined"
              size="small"
              label=""
              disabled={isDisabled}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

CarryForwardRules.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    labels: PropTypes.shape({
      limit: PropTypes.string,
      expiry: PropTypes.string,
    }),
  }).isRequired,
  value: PropTypes.shape({
    limit: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    expiry: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    expiryUnit: PropTypes.string,
  }),
  name: PropTypes.string.isRequired,
  setFormValues: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};

CarryForwardRules.defaultProps = {
  value: {},
  isDisabled: false,
};

export default CarryForwardRules;
